import { useQuery, useQueryClient } from '@tanstack/react-query';
import { subscriptionService, UserSubscription } from '@/services/subscriptionService';
import { queryKeys } from '@/lib/query-client';

/**
 * Hook for fetching and caching subscription data.
 * Stale time: 5 minutes (subscription rarely changes, only on payment events)
 */
export function useSubscription() {
  return useQuery({
    queryKey: queryKeys.subscription,
    queryFn: () => subscriptionService.getUserSubscription(),
    staleTime: 5 * 60 * 1000,  // 5 minutes - subscription rarely changes
  });
}

/**
 * Hook for invalidating subscription cache.
 * Use after successful payment/checkout.
 */
export function useInvalidateSubscription() {
  const queryClient = useQueryClient();
  
  return () => {
    queryClient.invalidateQueries({ queryKey: queryKeys.subscription });
  };
}

/**
 * Get cached subscription data without triggering a fetch.
 * Returns undefined if not in cache.
 */
export function useSubscriptionData(): UserSubscription | undefined {
  const queryClient = useQueryClient();
  return queryClient.getQueryData<UserSubscription>(queryKeys.subscription);
}
